import _ from 'lodash'

export const customerAllocationRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      officeId: el.officeId,
      officeName: el.officeName,
      id: i + 1,
      customerNumber: el?.customerNumber,
      customerName: el.customerName,
      customerStatus: el.customerStatus,
      addressDetail: el.addressDetail,
      addressNumber: el.addressNumber,
      addressRoad: el.addressRoad,
      assignStatus: el.assignStatus,
      assignFromId: el.assignFromId,
      assignFromName: el.assignFromName,
      assignToId: el.assignToId,
      assignToName: el.assignToName,
    }
  })
}
export const customerInfoRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      rn: el?.rn,
      addressDetail: el.addressDetail === null ? '' : el.addressDetail,
      addressNumber: el.addressNumber,
      addressRoad: el.addressRoad,
      batteryLevel: el.batteryLevel,
      brightness: el.brightness,
      checkDay: el.checkDay,
      checkCreateAt: el.checkCreateAt,
      checkDecimalValue: el.checkDecimalValue,
      checkMonth: el.checkMonth,
      contractNumber: el.contractNumber,
      customerStatus: el.customerStatus,
      contrast: el.contrast,
      installAt: el.installAt,
      asIdx: el.asIdx,
      installerName: el.installerName,
      customerTypeId: el.customerTypeId,
      customerTypeName: el.customerTypeName,
      customerWorkTypeName: el.customerWorkTypeName,
      customerWorkTypeId: el.customerWorkTypeId,
      deviceCommFailCount: el.deviceCommFailCount,
      deviceConnectAt: el.deviceConnectAt,
      deviceType: el.deviceType,
      deviceTypeName: el.deviceTypeName,
      deviceVersion: el.deviceVersion,
      processStatus: el.process_status,
      phoneNumber: el.phoneNumber,
      digit: el.digit,
      deviceStatus: el.deviceStatus,
      meterReadCommFailCount: el.meterReadCommFailCount,
      efosConnectAt: el.efosConnectAt,
      efosStatus: el.efosStatus,
      latitude: el.latitude,
      longitude: el.longitude,
      memo: el.memo,
      managerName: el.managerName,
      meterReadInstallDate: el.meterReadInstallDate,
      meterReadSerialNumber: el.meterReadSerialNumber,
      meterReadVersion: el.meterReadVersion,
      remainDurability: el.remainDurability,
      rotate: el.rotate,
      serverCycle: el.serverCycle,
      signalStrength: el.signalStrength,
      checkValue: el.checkValue,
      cooperIdx: el.cooperIdx,
      cooperName: el.cooperName,
      customerName: el.customerName,
      customerNumber: el.customerNumber,
      deviceApplyStatus: el.deviceApplyStatus,
      filePath: el.filePath,
      filter2: el.filter2,
      meterManufacturer: el.meterManufacturer,
      imageIdxDate: el.imageIdxDate,
      imei: el.imei,
      meterDiameter: el.meterDiameter,
      meterNumber: el.meterNumber,
      officeId: el.officeId,
      officeName: el.officeName,
      serialNumber: el.serialNumber,
      temperature: el.temperature,
      updateCheckValue: el.updateCheckValue,
      updateCheckdecimalValue: el.updateCheckdecimalValue,
      xfrom: el.xfrom,
      yfrom: el.yfrom,
      xto: el.xto,
      yto: el.yto,
      recognizedType: el?.recognizedType,
      revisionPath: el.revisionPath,
      externalSerialNumber: el.externalSerialNumber,
      installCameraPhoto: el?.installCameraPhoto,
      installCommLinePhoto: el?.installCommLinePhoto,
      installEnvPhoto: el?.installEnvPhoto,
      installMeterReadPhoto: el?.installMeterReadPhoto,
      installOutletBoxPhoto: el?.installOutletBoxPhoto,
      installPhoto: el?.installPhoto,
      installSignPhoto: el?.installSignPhoto,
      installWrongPhoto: el?.installWrongPhoto,
      isExternalDisplayInstalled: el?.isExternalDisplayInstalled,
      isOuterCaseInstalled: el?.isOuterCaseInstalled,
      outerCaseSizeType: el?.outerCaseSizeType,
      installExtraPhoto: el?.installExtraPhoto,
      existsInstallPhoto: el?.existsInstallPhoto,
      managerPhoneNumber: el?.managerPhoneNumber,
    }
  })
}
export const customerHmdInfoRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      rn: el?.rn,
      addressDetail: el.address_detail === null ? '' : el.address_detail,
      addressNumber: el.address_number,
      addressRoad: el.address_road,
      batteryLevel: el.batteryLevel,
      brightness: el.brightness,
      checkDay: el.check_day,
      checkCreateAt: el.checkCreateAt,
      checkDecimalValue: el.check_decimal_value,
      checkMonth: el.check_month,
      contractNumber: el.contractNumber,
      customerStatus: el.customerStatus,
      contrast: el.contrast,
      installAt: el.installAt,
      asIdx: el.asIdx,
      installerName: el.installerName,
      customerTypeId: el.customerTypeId,
      customerTypeName: el.customerTypeName,
      customerWorkTypeName: el.customerWorkTypeName,
      customerWorkTypeId: el.customerWorkTypeId,
      deviceCommFailCount: el.deviceCommFailCount,
      deviceConnectAt: el.last_send_at,
      deviceType: el.device_type,
      deviceTypeName: el.device_type_name,
      deviceVersion: el.deviceVersion,
      processStatus: el.processStatus,
      phoneNumber: el.phoneNumber,
      digit: el.digit,
      deviceStatus: el.update_at,
      meterReadCommFailCount: el.meterReadCommFailCount,
      efosConnectAt: el.check_meter_at,
      efosStatus: el.last_send_at,
      latitude: el.latitude,
      longitude: el.longitude,
      memo: el.memo,
      managerName: el.manager_name,
      meterReadInstallDate: el.meterReadInstallDate,
      meterReadSerialNumber: el.meterReadSerialNumber,
      meterReadVersion: el.meterReadVersion,
      remainDurability: el.remainDurability,
      rotate: el.rotate,
      serverCycle: el.serverCycle,
      signalStrength: el.signalStrength,
      checkValue: el.check_value,
      cooperIdx: el.cooperIdx,
      cooperName: el.cooperName,
      customerName: el.customer_name,
      customerNumber: el.customer_number,
      deviceApplyStatus: el.deviceApplyStatus,
      filePath: el.file_path,
      filter2: el.filter2,
      meterManufacturer: el.meterManufacturer,
      imageIdxDate: el.imageIdxDate,
      imei: el.imei,
      meterDiameter: el.meter_diameter,
      meterNumber: el.meter_number,
      officeId: el.office_id,
      officeName: el.office_name,
      serialNumber: el.serial_number,
      temperature: el.temperature,
      updateCheckValue: el.updateCheckValue,
      updateCheckdecimalValue: el.updateCheckdecimalValue,
      xfrom: el.xfrom,
      yfrom: el.yfrom,
      xto: el.xto,
      yto: el.yto,
      recognizedType: el?.recognizedType,
      revisionPath: el.revisionPath,
      externalSerialNumber: el.externalSerialNumber,
      installCameraPhoto: el?.installCameraPhoto,
      installCommLinePhoto: el?.installCommLinePhoto,
      installEnvPhoto: el?.installEnvPhoto,
      installMeterReadPhoto: el?.installMeterReadPhoto,
      installOutletBoxPhoto: el?.installOutletBoxPhoto,
      installPhoto: el?.installPhoto,
      installSignPhoto: el?.installSignPhoto,
      installWrongPhoto: el?.installWrongPhoto,
      isExternalDisplayInstalled: el?.isExternalDisplayInstalled,
      isOuterCaseInstalled: el?.isOuterCaseInstalled,
      outerCaseSizeType: el?.outerCaseSizeType,
      installExtraPhoto: el?.installExtraPhoto,
      existsInstallPhoto: el?.existsInstallPhoto,
      managerPhoneNumber: el?.managerPhoneNumber,
      latestImageFilePath: el?.latest_image_file_path,
      latestImageFileName: el?.latest_image_file_name,
      latestImageIdxDate: el?.latest_image_idx_date,
      latestImageCreateAt: el?.latest_image_create_at,
    }
  })
}
export const customerInfoBoardVersionRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      rn: el?.rn,
      asInstallerName: el.asInstallerName,
      addressDetail: el.addressDetail === null ? '' : el.addressDetail,
      addressNumber: el.addressNumber,
      addressRoad: el.addressRoad,
      batteryLevel: el.batteryLevel,
      brightness: el.brightness,
      boardVersion: el.boardVersion,
      checkDay: el.checkDay,
      checkCreateAt: el.checkCreateAt,
      checkDecimalValue: el.checkDecimalValue,
      checkMonth: el.checkMonth,
      contractNumber: el.contractNumber,
      customerStatus: el.customerStatus,
      contrast: el.contrast,
      installAt: el.installAt,
      asIdx: el.asIdx,
      installerName: el.installerName,
      customerTypeId: el.customerTypeId,
      customerTypeName: el.customerTypeName,
      customerWorkTypeName: el.customerWorkTypeName,
      customerWorkTypeId: el.customerWorkTypeId,
      deviceCommFailCount: el.deviceCommFailCount,
      deviceConnectAt: el.deviceConnectAt,
      deviceType: el.deviceType,
      deviceTypeName: el.deviceTypeName,
      deviceVersion: el.deviceVersion,
      processStatus: el.processStatus,
      phoneNumber: el.phoneNumber,
      digit: el.digit,
      deviceStatus: el.deviceStatus,
      meterReadCommFailCount: el.meterReadCommFailCount,
      efosConnectAt: el.efosConnectAt,
      efosStatus: el.efosStatus,
      latitude: el.latitude,
      longitude: el.longitude,
      memo: el.memo,
      managerName: el.managerName,
      meterReadInstallDate: el.meterReadInstallDate,
      meterReadSerialNumber: el.meterReadSerialNumber,
      meterReadVersion: el.meterReadVersion,
      remainDurability: el.remainDurability,
      rotate: el.rotate,
      serverCycle: el.serverCycle,
      signalStrength: el.signalStrength,
      checkValue: el.checkValue,
      cooperIdx: el.cooperIdx,
      cooperName: el.cooperName,
      customerName: el.customerName,
      customerNumber: el.customerNumber,
      deviceApplyStatus: el.deviceApplyStatus,
      filePath: el.filePath,
      filter2: el.managerPhoneNumber,
      meterManufacturer: el.meterManufacturer,
      imageIdxDate: el.imageIdxDate,
      imei: el.imei,
      meterDiameter: el.meterDiameter,
      meterNumber: el.meterNumber,
      officeId: el.officeId,
      officeName: el.officeName,
      serialNumber: el.serialNumber,
      temperature: el.temperature,
      updateCheckValue: el.updateCheckValue,
      updateCheckdecimalValue: el.updateCheckdecimalValue,
      xfrom: el.xfrom,
      yfrom: el.yfrom,
      xto: el.xto,
      yto: el.yto,
      recognizedType: el.recognizedType,
      revisionPath: el.revisionPath,
      externalSerialNumber: el.externalSerialNumber,
      installCameraPhoto: el?.installCameraPhoto,
      installCommLinePhoto: el?.installCommLinePhoto,
      installEnvPhoto: el?.installEnvPhoto,
      installMeterReadPhoto: el?.installMeterReadPhoto,
      installOutletBoxPhoto: el?.installOutletBoxPhoto,
      installPhoto: el?.installPhoto,
      installSignPhoto: el?.installSignPhoto,
      installWrongPhoto: el?.installWrongPhoto,
      isExternalDisplayInstalled: el?.isExternalDisplayInstalled,
      isOuterCaseInstalled: el?.isOuterCaseInstalled,
      outerCaseSizeType: el?.outerCaseSizeType,
      installExtraPhoto: el?.installExtraPhoto,
      existsInstallPhoto: el?.existsInstallPhoto,
      lwm2mIp: el?.lwm2mIp,
      lwm2mPort: el?.lwm2mPort,
      imageIpPort: el?.imageIpPort,
      firmwareVersion: el?.firmwareVersion,
      imageWidth: el?.imageWidth,
      imageHeight: el?.imageHeight,
      managerPhoneNumber: el?.managerPhoneNumber,
      completeSignalStrength: el?.completeSignalStrength,
      completeLinkquality: el?.completeLinkquality,
    }
  })
}

/**
 * 검침 이미지 검증
 */
export const customerBinaryCheckRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      rn: el?.rn,
      asIdx: el?.asIdx,
      asInstallerName: el?.asInstallerName,
      officeId: el?.officeId,
      officeName: el?.officeName,
      customerTypeId: el?.customerTypeId,
      customerTypeName: el?.customerTypeName,
      customerWorkTypeId: el?.customerWorkTypeId,
      customerWorkTypeName: el?.customerWorkTypeName,
      customerNumber: el?.customerNumber,
      customerName: el?.customerName,
      customerStatus: el?.customerStatus,
      addressNumber: el?.addressNumber,
      addressRoad: el?.addressRoad,
      addressDetail: el?.addressDetail,
      phoneNumber: el?.phoneNumber,
      checkMonth: el?.checkMonth,
      checkDay: el?.checkDay,
      memo: el?.memo,
      managerName: el?.managerName,
      managerPhoneNumber: el?.managerPhoneNumber,
      meterManufacturer: el?.meterManufacturer,
      meterNumber: el?.meterNumber,
      meterDiameter: el?.meterDiameter,
      imei: el?.imei,
      deviceType: el?.deviceType,
      deviceTypeName: el?.deviceTypeName,
      serialNumber: el?.serialNumber,
      cooperIdx: el?.cooperIdx,
      cooperName: el?.cooperName,
      signalStrength: el?.signalStrength,
      batteryLevel: el?.batteryLevel,
      batteryStatus: el?.batteryStatus,
      meterReadSerialNumber: el?.meterReadSerialNumber,
      meterReadInstallDate: el?.meterReadInstallDate,
      meterReadCommFailCount: el?.meterReadCommFailCount,
      meterReadVersion: el?.meterReadVersion,
      deviceCommFailCount: el?.deviceCommFailCount,
      deviceVersion: el?.deviceVersion,
      deviceApplyStatus: el?.deviceApplyStatus,
      temperature: el?.temperature,
      rotate: el?.rotate,
      digit: el?.digit,
      contrast: el?.contrast,
      brightness: el?.brightness,
      latitude: el?.latitude,
      longitude: el?.longitude,
      remainDurability: el?.remainDurability,
      deviceStatus: el?.deviceStatus,
      efosStatus: el?.efosStatus,
      deviceConnectAt: el?.deviceConnectAt,
      efosConnectAt: el?.efosConnectAt,
      installAt: el?.installAt,
      recognizedType: el?.recognizedType,
      installerId: el?.installerId,
      installerName: el?.installerName,
      boardVersion: el?.boardVersion,
      eidxDate: el?.eidxDate,
      sidxDate: el?.sidxDate,
      // A/S 등록(POST /as) 시 마지막 날짜 이미지를 기준으로 보낸다
      imageIdxDate: el?.eidxDate,
      simageHash: el?.simageHash,
      efilePath: el?.efilePath,
      sfilePath: el?.sfilePath,
      eimageHash: el?.eimageHash,
    }
  })
}

export const customerFlaggedReviewRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      rn: el?.rn,
      asIdx: el?.asIdx,
      asInstallerName: el?.asInstallerName,
      officeId: el?.officeId,
      officeName: el?.officeName,
      customerTypeId: el?.customerTypeId,
      customerTypeName: el?.customerTypeName,
      customerWorkTypeId: el?.customerWorkTypeId,
      customerWorkTypeName: el?.customerWorkTypeName,
      customerNumber: el?.customerNumber,
      customerName: el?.customerName,
      customerStatus: el?.customerStatus,
      addressNumber: el?.addressNumber,
      addressRoad: el?.addressRoad,
      addressDetail: el?.addressDetail,
      phoneNumber: el?.phoneNumber,
      checkMonth: el?.checkMonth,
      checkDay: el?.checkDay,
      checkValue: el?.checkValue,
      checkDecimalValue: el?.checkDecimalValue,
      memo: el?.memo,
      managerName: el?.managerName,
      managerPhoneNumber: el?.managerPhoneNumber,
      meterManufacturer: el?.meterManufacturer,
      meterNumber: el?.meterNumber,
      meterDiameter: el?.meterDiameter,
      imei: el?.imei,
      deviceType: el?.deviceType,
      deviceTypeName: el?.deviceTypeName,
      serialNumber: el?.serialNumber,
      cooperIdx: el?.cooperIdx,
      cooperName: el?.cooperName,
      signalStrength: el?.signalStrength,
      batteryLevel: el?.batteryLevel,
      batteryStatus: el?.batteryStatus,
      meterReadSerialNumber: el?.meterReadSerialNumber,
      meterReadInstallDate: el?.meterReadInstallDate,
      meterReadCommFailCount: el?.meterReadCommFailCount,
      meterReadVersion: el?.meterReadVersion,
      deviceCommFailCount: el?.deviceCommFailCount,
      deviceVersion: el?.deviceVersion,
      deviceApplyStatus: el?.deviceApplyStatus,
      temperature: el?.temperature,
      rotate: el?.rotate,
      digit: el?.digit,
      contrast: el?.contrast,
      brightness: el?.brightness,
      latitude: el?.latitude,
      longitude: el?.longitude,
      remainDurability: el?.remainDurability,
      deviceStatus: el?.deviceStatus,
      efosStatus: el?.efosStatus,
      deviceConnectAt: el?.deviceConnectAt,
      efosConnectAt: el?.efosConnectAt,
      installAt: el?.installAt,
      recognizedType: el?.recognizedType,
      installerId: el?.installerId,
      installerName: el?.installerName,
      boardVersion: el?.boardVersion,
      filePath: el?.filePath,
      revisionPath: el?.revisionPath,
      imageIdxDate: el?.imageIdxDate,
      processStatus: el?.processStatus,
      existsInstallPhoto: el?.existsInstallPhoto,
      completeSignalStrength: el?.completeSignalStrength,
      completeLinkquality: el?.completeLinkquality,
      issueTypes: el?.issueTypes ?? [],
    }
  })
}

export const customerInfoCorrectRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      addressDetail: el.addressDetail === null ? '' : el.addressDetail,
      addressNumber: el.addressNumber,
      addressRoad: el.addressRoad,
      asInstaller: el.asInstaller,
      batteryLevel: el.batteryLevel,
      brightness: el.brightness,
      boardVersion: el.boardVersion,
      checkDay: el.checkDay,
      checkCreateAt: el.checkCreateAt,
      checkDecimalValue: el.checkDecimalValue,
      checkMonth: el.checkMonth,
      contractNumber: el.contractNumber,
      customerStatus: el.customerStatus,
      contrast: el.contrast,
      installAt: el.installAt,
      asIdx: el.asIdx,
      installerName: el.installerName,
      customerTypeId: el.customerTypeId,
      customerTypeName: el.customerTypeName,
      customerWorkTypeName: el.customerWorkTypeName,
      customerWorkTypeId: el.customerWorkTypeId,
      deviceCommFailCount: el.deviceCommFailCount,
      deviceConnectAt: el.deviceConnectAt,
      deviceType: el.deviceType,
      deviceTypeName: el.deviceTypeName,
      deviceVersion: el.deviceVersion,
      processStatus: el.processStatus,
      phoneNumber: el.phoneNumber,
      digit: el.digit,
      deviceStatus: el.deviceStatus,
      meterReadCommFailCount: el.meterReadCommFailCount,
      efosConnectAt: el.efosConnectAt,
      efosStatus: el.efosStatus,
      latitude: el.latitude,
      longitude: el.longitude,
      memo: el.memo,
      managerName: el.managerName,
      meterReadInstallDate: el.meterReadInstallDate,
      meterReadSerialNumber: el.meterReadSerialNumber,
      meterReadVersion: el.meterReadVersion,
      remainDurability: el.remainDurability,
      rotate: el.rotate,
      serverCycle: el.serverCycle,
      signalStrength: el.signalStrength,
      checkValue: el.checkValue,
      cooperIdx: el.cooperIdx,
      cooperName: el.cooperName,
      customerName: el.customerName,
      customerNumber: el.customerNumber,
      deviceApplyStatus: el.deviceApplyStatus,
      filePath: el.filePath,
      filter2: el.managerPhoneNumber,
      imageIdxDate: el.imageIdxDate,
      imei: el.imei,
      meterDiameter: el.meterDiameter,
      meterNumber: el.meterNumber,
      officeId: el.officeId,
      officeName: el.officeName,
      serialNumber: el.serialNumber,
      temperature: el.temperature,
      updateCheckValue: el.updateCheckValue,
      updateCheckdecimalValue: el.updateCheckdecimalValue,
      xfrom: el.xfrom,
      yfrom: el.yfrom,
      xto: el.xto,
      yto: el.yto,
      recognizedType: el.recognizedType,
      revisionPath: el.revisionPath,
    }
  })
}
export const customerInfoCorrectResultRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      addressDetail: el.addressDetail === null ? '' : el.addressDetail,
      addressNumber: el.addressNumber,
      addressRoad: el.addressRoad,
      batteryLevel: el.batteryLevel,
      brightness: el.brightness,
      boardVersion: el.boardVersion,
      checkDay: el.checkDay,
      checkCreateAt: el.checkCreateAt,
      checkDecimalValue: el.checkDecimalValue,
      checkMonth: el.checkMonth,
      contractNumber: el.contractNumber,
      customerStatus: el.customerStatus,
      contrast: el.contrast,
      installAt: el.installAt,
      asIdx: el.asIdx,
      installerName: el.installerName,
      customerTypeId: el.customerTypeId,
      customerTypeName: el.customerTypeName,
      customerWorkTypeName: el.customerWorkTypeName,
      customerWorkTypeId: el.customerWorkTypeId,
      deviceCommFailCount: el.deviceCommFailCount,
      deviceConnectAt: el.deviceConnectAt,
      deviceType: el.deviceType,
      deviceTypeName: el.deviceTypeName,
      deviceVersion: el.deviceVersion,
      processStatus: el.processStatus,
      phoneNumber: el.phoneNumber,
      digit: el.digit,
      deviceStatus: el.deviceStatus,
      meterReadCommFailCount: el.meterReadCommFailCount,
      efosConnectAt: el.efosConnectAt,
      efosStatus: el.efosStatus,
      latitude: el.latitude,
      longitude: el.longitude,
      memo: el.memo,
      managerName: el.managerName,
      meterReadInstallDate: el.meterReadInstallDate,
      meterReadSerialNumber: el.meterReadSerialNumber,
      meterReadVersion: el.meterReadVersion,
      remainDurability: el.remainDurability,
      rotate: el.rotate,
      serverCycle: el.serverCycle,
      signalStrength: el.signalStrength,
      checkValue: el.checkValue,
      cooperIdx: el.cooperIdx,
      cooperName: el.cooperName,
      customerName: el.customerName,
      customerNumber: el.customerNumber,
      deviceApplyStatus: el.deviceApplyStatus,
      filePath: el.filePath,
      filter2: el.managerPhoneNumber,
      imageIdxDate: el.imageIdxDate,
      imei: el.imei,
      meterDiameter: el.meterDiameter,
      meterNumber: el.meterNumber,
      officeId: el.officeId,
      officeName: el.officeName,
      serialNumber: el.serialNumber,
      temperature: el.temperature,
      updateCheckValue: el.updateCheckValue,
      updateCheckdecimalValue: el.updateCheckdecimalValue,
      xfrom: el.xfrom,
      yfrom: el.yfrom,
      xto: el.xto,
      yto: el.yto,
      recognizedType: el.recognizedType,
      revisionPath: el.revisionPath,
    }
  })
}

export const customerRemoveResultRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      addressDetail: el?.addressDetail === null ? '' : el?.addressDetail,
      addressNumber: el.addressNumber,
      addressRoad: el.addressRoad,
      batteryLevel: el.batteryLevel,
      brightness: el.brightness,
      boardVersion: el.boardVersion,
      checkDay: el.checkDay,
      checkCreateAt: el.checkCreateAt,
      checkDecimalValue: el.checkDecimalValue,
      checkMonth: el.checkMonth,
      contractNumber: el.contractNumber,
      customerStatus: el.customerStatus,
      contrast: el.contrast,
      installAt: el.installAt,
      asIdx: el.asIdx,
      installerName: el.installerName,
      customerTypeId: el.customerTypeId,
      customerTypeName: el.customerTypeName,
      customerWorkTypeName: el.customerWorkTypeName,
      customerWorkTypeId: el.customerWorkTypeId,
      deviceCommFailCount: el.deviceCommFailCount,
      deviceConnectAt: el.deviceConnectAt,
      deviceType: el.deviceType,
      deviceTypeName: el.deviceTypeName,
      deviceVersion: el.deviceVersion,
      processStatus: el.processStatus,
      phoneNumber: el.phoneNumber,
      digit: el.digit,
      deviceStatus: el.deviceStatus,
      meterReadCommFailCount: el.meterReadCommFailCount,
      efosConnectAt: el.efosConnectAt,
      efosStatus: el.efosStatus,
      latitude: el.latitude,
      longitude: el.longitude,
      memo: el.memo,
      managerName: el.managerName,
      meterReadInstallDate: el.meterReadInstallDate,
      meterReadSerialNumber: el.meterReadSerialNumber,
      meterReadVersion: el.meterReadVersion,
      remainDurability: el.remainDurability,
      rotate: el.rotate,
      serverCycle: el.serverCycle,
      signalStrength: el.signalStrength,
      checkValue: el.checkValue,
      cooperIdx: el.cooperIdx,
      cooperName: el.cooperName,
      customerName: el.customerName,
      customerNumber: el.customerNumber,
      deviceApplyStatus: el.deviceApplyStatus,
      filePath: el.filePath,
      filter2: el.managerPhoneNumber,
      meterManufacturer: el.meterManufacturer,
      imageIdxDate: el.imageIdxDate,
      imei: el.imei,
      meterDiameter: el.meterDiameter,
      meterNumber: el.meterNumber,
      officeId: el.officeId,
      officeName: el.officeName,
      serialNumber: el.serialNumber,
      temperature: el.temperature,
      updateCheckValue: el.updateCheckValue,
      updateCheckdecimalValue: el.updateCheckdecimalValue,
      xfrom: el.xfrom,
      yfrom: el.yfrom,
      xto: el.xto,
      yto: el.yto,
      recognizedType: el.recognizedType,
      revisionPath: el.revisionPath,
      externalSerialNumber: el.externalSerialNumber,
      installCameraPhoto: el?.installCameraPhoto,
      installCommLinePhoto: el?.installCommLinePhoto,
      installEnvPhoto: el?.installEnvPhoto,
      installMeterReadPhoto: el?.installMeterReadPhoto,
      installOutletBoxPhoto: el?.installOutletBoxPhoto,
      installPhoto: el?.installPhoto,
      installSignPhoto: el?.installSignPhoto,
      installWrongPhoto: el?.installWrongPhoto,
      isExternalDisplayInstalled: el?.isExternalDisplayInstalled,
      isOuterCaseInstalled: el?.isOuterCaseInstalled,
      outerCaseSizeType: el?.outerCaseSizeType,
      installExtraPhoto: el?.installExtraPhoto,
      existsInstallPhoto: el?.existsInstallPhoto,
    }
  })
}

export const customerPhotoRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      addressDetail: el.addressDetail === null ? '' : el.addressDetail,
      addressNumber: el.addressNumber,
      addressRoad: el.addressRoad,
      batteryLevel: el.batteryLevel,
      brightness: el.brightness,
      boardVersion: el.boardVersion,
      checkDay: el.checkDay,
      checkCreateAt: el.checkCreateAt,
      checkDecimalValue: el.checkDecimalValue,
      checkMonth: el.checkMonth,
      contractNumber: el.contractNumber,
      customerStatus: el.customerStatus,
      contrast: el.contrast,
      installAt: el.installAt,
      asIdx: el.asIdx,
      installerName: el.installerName,
      customerTypeId: el.customerTypeId,
      customerTypeName: el.customerTypeName,
      customerWorkTypeName: el.customerWorkTypeName,
      customerWorkTypeId: el.customerWorkTypeId,
      deviceCommFailCount: el.deviceCommFailCount,
      deviceConnectAt: el.deviceConnectAt,
      deviceType: el.deviceType,
      deviceTypeName: el.deviceTypeName,
      deviceVersion: el.deviceVersion,
      processStatus: el.processStatus,
      phoneNumber: el.phoneNumber,
      digit: el.digit,
      deviceStatus: el.deviceStatus,
      meterReadCommFailCount: el.meterReadCommFailCount,
      efosConnectAt: el.efosConnectAt,
      efosStatus: el.efosStatus,
      latitude: el.latitude,
      longitude: el.longitude,
      memo: el.memo,
      managerName: el.managerName,
      meterReadInstallDate: el.meterReadInstallDate,
      meterReadSerialNumber: el.meterReadSerialNumber,
      meterReadVersion: el.meterReadVersion,
      remainDurability: el.remainDurability,
      rotate: el.rotate,
      serverCycle: el.serverCycle,
      signalStrength: el.signalStrength,
      checkValue: el.checkValue,
      cooperIdx: el.cooperIdx,
      cooperName: el.cooperName,
      customerName: el.customerName,
      customerNumber: el.customerNumber,
      deviceApplyStatus: el.deviceApplyStatus,
      filePath: el.filePath,
      filter2: el.managerPhoneNumber,
      imageIdxDate: el.imageIdxDate,
      imei: el.imei,
      meterDiameter: el.meterDiameter,
      meterNumber: el.meterNumber,
      officeId: el.officeId,
      officeName: el.officeName,
      serialNumber: el.serialNumber,
      temperature: el.temperature,
      updateCheckValue: el.updateCheckValue,
      updateCheckdecimalValue: el.updateCheckdecimalValue,
      xfrom: el.xfrom,
      yfrom: el.yfrom,
      xto: el.xto,
      yto: el.yto,
      recognizedType: el.recognizedType,
      revisionPath: el.revisionPath,
      installCameraPhoto: el?.installCameraPhoto,
      installCommLinePhoto: el?.installCommLinePhoto,
      installEnvPhoto: el?.installEnvPhoto,
      installMeterReadPhoto: el?.installMeterReadPhoto,
      installOutletBoxPhoto: el?.installOutletBoxPhoto,
      installPhoto: el?.installPhoto,
      installSignPhoto: el?.installSignPhoto,
      installWrongPhoto: el?.installWrongPhoto,
    }
  })
}

export const customerActivityRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i,
      address: el?.address,
      checkCreateAt: el?.checkCreateAt,
      checkDecimalValue: el?.checkDecimalValue,
      checkModelList: el?.checkModelList,
      checkValue: el?.checkValue,
      customerName: el?.customerName,
      customerNumber: el?.customerNumber,
      customerTypeId: el?.customerTypeId,
      customerTypeName: el?.customerTypeName,
      cooperName: el?.cooperName,
      deviceStatus: el?.deviceStatus,
      deviceType: el?.deviceType,
      efosStatus: el?.efosStatus,
      filePath: el?.filePath,
      imageIdxDate: el?.imageIdxDate,
      latitude: el?.latitude,
      longitude: el?.longitude,
      officeId: el?.officeId,
      officeName: el?.officeName,
      managerName: el?.managerName,
    }
  })
}

export const customerCheckListRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      officeId: el?.officeId,
      customerNumber: el?.customerNumber,
      customerName: el?.customerName,
      checkMeterList: el?.checkMeterList,
      processStatus: el?.processStatus,
      filePath: el?.filePath,
      idxDate: el?.idxDate,
      imageSendAt: el?.imageSendAt,
      address: el?.address,
      cooperName: el?.cooperName,
      managerName: el?.managerName,
      recognizedType: el?.recognizedType,
    }
  })
}

export const customerCheckReportRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      customerNumber: el.customerNumber,
      cooperIdx: el.cooperIdx,
      checkDay: el.checkDay,
      customerName: el.customerName,
      cooperName: el.cooperName,
      address: el.address,
      endCheckValue: el.endCheckValue,
      endCheckDecimalValue: el.endCheckDecimalValue,
      endFilePath: el.endFilePath,
      endIdxDate: el.endIdxDate,
      managerName: el.managerName,
      meterDiameter: el.meterDiameter,
      officeId: el.officeId,
      deviceType: el.deviceType,
      startCheckDecimalValue: el.startCheckDecimalValue,
      startCheckValue: el.startCheckValue,
      startFilePath: el.startFilePath,
      startIdxDate: el.startIdxDate,
      startImei: el.startImei,
      startRotate: el.startRotate,
      endRotate: el.endRotate,
      endImei: el.endImei,
      startRecognizedType: el?.startRecognizedType,
      endRecognizedType: el?.endRecognizedType,
    }
  })
}

export const customerMinimumFlowRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      officeId: el?.officeId,
      customerNumber: el.customerNumber,
      customerName: el?.customerName,
      address: el?.address,
      checkMeterList: el?.checkMeterList,
      cooperName: el?.cooperName,
      managerName: el?.managerName,
      rotate: el?.rotate,
      totalUsage: _.sumBy(el?.checkMeterList, (el: any) => {
        return Number(el.use)
      }),
    }
  })
}

export const customerLeakageRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      officeId: el.officeId,
      checkList: el.checkList,
      customerNumber: el.customerNumber,
      leakCheckValue: el.leakCheckValue,
      leakFilePath: el.leakFilePath,
      leakIdxDate: el.leakIdxDate,
      leakStatus: el.leakStatus,
      customerName: el.customerName,
      addressRoad: el.address,
      leakUseUse: el.leakUseUse,
      todayUse: el.todayUse,
      todayCheckValue: el.todayCheckValue,
      todayFilePath: el.todayFilePath,
      todayIdxDate: el.todayIdxDate,
      avg: el.avg,
      calEndDate: el.calEndDate,
      calStartDate: el.calStartDate,
      leakUseCycle: el.leakUseCycle,
      usedAmountUntilRecent: el.usedAmountUntilRecent,
      usedAmountUntilToday: el.usedAmountUntilToday,
      meterNumber: el.meterNumber,
      meterDiameter: el.meterDiameter,
      imei: el.imei,
      serialNumber: el.serialNumber,
      recognizedType: el.recognizedType,
      deviceType: el.deviceType,
      cooperName: el.cooperName,
      managerName: el.managerName,
      rotate: el.rotate,
    }
  })
}

export const customerLeakageDetailUncertainListRows = (list: any) => {
  const result = _.chain(list)
    .map((el, i) => ({
      id: i + 1,
      customerName: el?.customerName,
      customerNumber: el?.customerNumber,
      address: el?.address,
      filePath: el?.filePath,
      lastIdxDate: el?.lastIdxDate,
      officeId: el?.officeId,
      rotate: el?.rotate,
    }))
    .filter((item) => item.customerNumber !== null || item.customerName !== null)
    .value()
  return result
}

export const customerLeakageDetailUncertainUserRows = (list: any) => {
  return _.map(list, (el, i) => {
    return {
      id: i + 1,
      checkDecimalValue: el?.checkDecimalValue,
      checkValue: el?.checkValue,
      createAt: el?.createAt,
      fileName: el?.fileName,
      filePath: el?.filePath,
      rotate: el?.rotate,
      idxDate: el?.idxDate,
      imei: el?.imei,
      processStatus: el?.processStatus,
      updateAt: el?.updateAt,
      updateCheckDecimalValue: el?.updateCheckDecimalValue,
      updateCheckValue: el?.updateCheckValue,
    }
  })
}

export const customerLongTermUnusedUserRows = (list: any) => {
  return _.map(list, (el, i) => {
    return {
      id: i + 1,
      customerName: el?.customerName,
      customerNumber: el?.customerNumber,
      address: el?.address,
      officeId: el?.officeId,
      longtermDayFilePath: el?.longtermDayFilePath,
      longtermDayIdxDate: el?.longtermDayIdxDate,
      longtermDayCheckValue: el?.longtermDayCheckValue,
      todayFilePath: el?.todayFilePath,
      todayIdxDate: el?.todayIdxDate,
      todayCheckValue: el?.todayCheckValue,
      managerName: el?.managerName,
      cooperName: el?.cooperName,
      rotate: el?.rotate,
    }
  })
}

export const customerFreezeWarningRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      addressDetail: el.addressDetail === null ? '' : el.addressDetail, //
      addressNumber: el.addressNumber, //
      addressRoad: el.addressRoad, //
      batteryLevel: el.batteryLevel, //
      checkDecimalValue: el.checkDecimalValue, //
      contractNumber: el.contractNumber, //
      deviceType: el.deviceType, //
      deviceStatus: el.deviceStatus, //
      efosConnectAt: el.efosConnectAt, //
      efosStatus: el.efosStatus, //
      managerName: el.managerName, //
      rotate: el.rotate, //
      checkValue: el.checkValue, //
      cooperIdx: el.cooperIdx, //
      cooperName: el.cooperName, //
      customerName: el.customerName, //
      customerNumber: el.customerNumber, //
      filePath: el.filePath,
      meterDiameter: el.meterDiameter, //
      officeId: el.officeId, //
      officeName: el.officeName, //
      serialNumber: el.serialNumber, //
      currentTemperature: el.currentTemperature, //
      recognizedType: el.recognizedType, //
      temperatureList: el.temperatureList,
    }
  })
}

export const customerTargetListRows = (list: any) => {
  return _.map(list, (el, i) => {
    return {
      id: i + 1,
      checkDecimalValue: el?.checkDecimalValue,
      checkValue: el?.checkValue,
      recognizedType: el?.recognizedType,
      createAt: el?.createAt,
      fileName: el?.fileName,
      filePath: el?.filePath,
      rotate: el?.rotate,
      idxDate: el?.idxDate,
      imei: el?.imei,
      processStatus: el?.processStatus,
      updateAt: el?.updateAt,
      updateCheckDecimalValue: el?.updateCheckDecimalValue,
      updateCheckValue: el?.updateCheckValue,
      temperature: el?.temperature,
      signalStrength: el?.signalStrength,
      linkquality: el?.linkquality,
    }
  })
}

// /customer-issue/checkmeters 응답 스키마 기준 매핑
export const flaggedReviewTargetListRows = (list: any) => {
  return _.map(list, (el: any, i: any) => {
    return {
      id: i + 1,
      checkDecimalValue: el?.checkDecimalValue,
      checkValue: el?.checkValue,
      recognizedType: el?.recognizedType,
      createAt: el?.createAt,
      filePath: el?.filePath,
      rotate: el?.rotate,
      idxDate: el?.idxDate,
      imei: el?.imei,
      processStatus: el?.processStatus,
      updateAt: el?.updateAt,
      updateCheckDecimalValue: el?.updateCheckDecimalValue,
      updateCheckValue: el?.updateCheckValue,
      temperature: el?.temperature,
      signalStrength: el?.signalStrength,
      linkquality: el?.linkquality,
      sameImageHash: el?.sameImageHash,
      issueTypes: el?.issueTypes ?? [],
    }
  })
}

export const customerStatusTargetListRows = (list: any) => {
  return _.map(list, (el, i) => {
    return {
      id: i + 1,
      checkDecimalValue: el?.checkDecimalValue,
      checkValue: el?.checkValue,
      createAt: el?.createAt,
      fileName: el?.fileName,
      filePath: el?.filePath,
      rotate: el?.rotate,
      idxDate: el?.idxDate,
      imei: el?.imei,
      processStatus: el?.processStatus,
      updateAt: el?.updateAt,
      updateCheckDecimalValue: el?.updateCheckDecimalValue,
      updateCheckValue: el?.updateCheckValue,
      temperature: el?.temperature,
      signalStrength: el?.signalStrength,
      recognizedType: el?.recognizedType,
    }
  })
}

export const customerHmdTargetListRows = (list: any) => {
  return _.map(list, (el, i) => {
    return {
      id: i + 1,
      checkDecimalValue: el?.check_decimal_value,
      checkValue: el?.check_value,
      createAt: el?.create_at,
      fileName: el?.file_name,
      filePath: el?.file_path,
      rotate: el?.rotate,
      idxDate: el?.idx_date,
      imei: el?.imei,
      processStatus: el?.process_status,
      updateAt: el?.update_at,
      updateCheckDecimalValue: el?.update_check_decimal_value,
      updateCheckValue: el?.update_check_value,
      temperature: el?.temperature,
      signalStrength: el?.rssi,
      rsrq: el?.rsrq,
      rsrp: el?.rsrp,
    }
  })
}
